import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, Box, TextField, Button, IconButton, Tooltip, Typography, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Heading from '../../Components/Heading/heading.tsx';
import { validateDriverName } from '../../Utils/NameValidation/name-validation.tsx';
import './editCompanyModal.scss'; 
import UploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import { validateEmail } from '../../Utils/EmailValidation/email-validation.tsx';
import { validatePhoneNumber } from '../../Utils/PhoneNumberValidation/phone-number-validation.tsx';
import { validatePincode } from '../../Utils/PincodeValidation/pincode-validation.tsx';
import { validatePassword } from '../../Utils/PasswordValidation/password-validation.tsx';
import { addCompany, addFeatures, getCompanyFeatures } from './action.ts';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import { validateBranchName } from '../../Utils/BranchNameValidation/branchname-validation.tsx';
import { validateAccountNumber } from '../../Utils/AccountNumberValidation/account-number-validation.tsx';
import { validateAddress } from '../../Utils/AddressValidation/address-validation.tsx';
import { validateIFSC } from '../../Utils/IFSCValidation/ifsc-validation.tsx';
import { validateCin } from '../../Utils/CinValidation/cin-validation.tsx';
import { validatePan } from '../../Utils/PANValidation/pan-validation.tsx';
import { validateTan } from '../../Utils/TANValidation/tan-validation.tsx';
import { validateGST } from '../../Utils/GSTValidation/gst-validation.tsx';
import { validateConfirmpassword } from '../../Utils/ConfirmPasswordValidation/confirm-password-validation.tsx';
import { validateCompanyName } from '../../Utils/NameValidation/name-validation.tsx';
import '../../Components/Tab/tab-style.scss';
import '../../Components/TextField/text-field-style.scss';
import StatusFilterTabs from '../../Components/Tab/tab.tsx'; 

const createMandatoryLabel = (labelText: string) => {
  return (
    <span>
      {labelText} <span style={{ color: 'red' }}>*</span>
    </span>
  );
};

interface AddCompanyModalProps {
  open: boolean;
  onClose: () => void;
}

interface NewValuesState {
  companyName: string;
  email: string;
  mobileNumber: string;
  address: string;
  pincode: string;
  bankName: string;
  branchName: string;
  accountName: string;
  accountNumber: string;
  ifsc: string;
  password: string;
  confirmPassword: string;
  brands: string;
  contactNameOne: string;
  contactNameTwo: string;
  contactNameThree: string;
  contactEmailOne: string;
  contactEmailTwo: string;
  contactEmailThree: string;
  contactDesignationOne: string;
  contactDesignationTwo: string;
  contactDesignationThree: string;
  contactNumberOne: string;
  contactNumberTwo: string;
  contactNumberThree: string;
  state: string;
  cin: string;
  pan: string;
  tan: string;
  gst: string;
}

const TAB_NAMES = ['Company', 'Details', 'Bank', 'Documents', 'Features'];

const AddCompanyModal = ({ open, onClose }: AddCompanyModalProps) => {
  
  const [activeTab, setActiveTab] = useState<string>(TAB_NAMES[0]);
  const [viewedTabs, setViewedTabs] = useState<string[]>([TAB_NAMES[0]]);
  const [type, setType] = useState('');
  const [typeError, setTypeError] = useState<boolean>(false);
  const [accountTypeError, setAccountTypeError] = useState<boolean>(false);
  const [accountType, setAccountType] = useState('');
  const [brandsError, setBrandsError] = useState(false);
  const [brandError, setBrandError] = useState('');
  const [tabError, setTabError] = useState<number | null>(null);
  const [selectedFeatures, setSelectedFeatures] = useState<number[]>([]);
  const [featuresList, setFeaturesList] = useState<any[]>([]);
  const [dashboardExpanded, setDashboardExpanded] = useState<boolean>(false);
  const [reportsExpanded, setReportsExpanded] = useState<boolean>(false);

  const [errors, setErrors] = useState({
    companyNameError: '', emailError: '', pincodeError: '', mobileNumberError: '', addressError: '',
    bankNameError: '', branchNameError: '', accountNameError: '', accountNumberError: '', ifscError: '',
    passwordError: '', confirmPasswordError: '', contactNameOneError: '', contactNameTwoError: '',
    contactNameThreeError: '', contactEmailOneError: '', contactEmailTwoError: '', contactEmailThreeError: '',
    contactNumberOneError: '', contactNumberTwoError: '', contactNumberThreeError: '', contactDesignationOneError: '',
    contactDesignationTwoError: '', contactDesignationThreeError: '', accountTypeError: '', stateError: '',
    cinError: '', panError: '', gstError: '', tanError: '',
  });

  const [newValues, setNewValues] = useState<NewValuesState>({
    companyName: '', email: '', mobileNumber: '', address: '', pincode: '', bankName: '', branchName: '',
    accountName: '', accountNumber: '', ifsc: '', password: '', confirmPassword: '', brands: '',
    contactNameOne: '', contactNameTwo: '', contactNameThree: '', contactEmailOne: '', contactEmailTwo: '',
    contactEmailThree: '', contactDesignationOne: '', contactDesignationTwo: '', contactDesignationThree: '',
    contactNumberOne: '', contactNumberTwo: '', contactNumberThree: '', state: '', cin: '', pan: '', tan: '', gst: '',
  });

  const [icons, setIcons] = useState<{ [key: string]: 'upload' | 'view' }>({
    pan: 'upload', tan: 'upload', gst: 'upload', cancelledCheque: 'upload', logo: 'upload'
  });

  const [selectedFiles, setSelectedFiles] = useState<{ [key: string]: File | null }>({
    pan: null, tan: null, gst: null, cancelledCheque: null, logo: null,
  });

  const maxFileSize = 1 * 1024 * 1024; 
  const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

  const typesOptions = [
    { id: 'vendor', label: 'Vendor'},
    { id: 'client', label: 'Client' },
  ];
  
  const accountTypesOptions = [
    { id: 'current', label: 'Current'},
    { id: 'recurring', label: 'Recurring'},
    { id: 'savings', label: 'Savings' },
  ];

  useEffect(() => {
    if (open) {
      getCompanyFeatures(
        '',
        1000, 
        0,    
         (response: any) => {
          const compFeatures = response?.message?.features || response?.data?.message?.features || response?.data || [];
          
          if (featuresList.length === 0) {
              setFeaturesList(compFeatures);
          }

          const preSelectedIds = compFeatures
            .filter((f: any) => f.checked === true)
            .map((f: any) => f.id);
            
          setSelectedFeatures(preSelectedIds);
          setInitialFeatures(preSelectedIds);
        },
      );
    }
  }, [open]);

  const resetState = () => {
    setActiveTab(TAB_NAMES[0]);
    setViewedTabs([TAB_NAMES[0]]);
    setType('');
    setAccountType('');
    setTypeError(false);
    setAccountTypeError(false);
    setSelectedFeatures([]);
    setErrors({
      companyNameError: '', emailError: '', pincodeError: '', mobileNumberError: '', addressError: '',
      bankNameError: '', branchNameError: '', accountNameError: '', accountNumberError: '', ifscError: '',
      passwordError: '', confirmPasswordError: '', contactNameOneError: '', contactNameTwoError: '',
      contactNameThreeError: '', contactEmailOneError: '', contactEmailTwoError: '', contactEmailThreeError: '',
      contactNumberOneError: '', contactNumberTwoError: '', contactNumberThreeError: '', contactDesignationOneError: '',
      contactDesignationTwoError: '', contactDesignationThreeError: '', accountTypeError: '', stateError: '',
      cinError: '', panError: '', gstError: '', tanError: '',
    });
    setNewValues({
      companyName: '', email: '', mobileNumber: '', address: '', pincode: '', bankName: '', branchName: '',
      accountName: '', accountNumber: '', ifsc: '', password: '', confirmPassword: '', brands: '',
      contactNameOne: '', contactNameTwo: '', contactNameThree: '', contactEmailOne: '', contactEmailTwo: '',
      contactEmailThree: '', contactDesignationOne: '', contactDesignationTwo: '', contactDesignationThree: '',
      contactNumberOne: '', contactNumberTwo: '', contactNumberThree: '', state: '', cin: '', pan: '', tan: '', gst: '',
    });
    setSelectedFiles({ pan: null, tan: null, gst: null, cancelledCheque: null, logo: null });
    setIcons({ pan: 'upload', tan: 'upload', gst: 'upload', cancelledCheque: 'upload', logo: 'upload' });
  };

  const handleTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = event.target.value as string;
    setType(selectedValue);
    if (selectedValue) {
      setTypeError(false); 
    }
  };

  const handleTabChange = (newTabName: string) => {
    const newTabIndex = TAB_NAMES.indexOf(newTabName);
    const currentTabIndex = TAB_NAMES.indexOf(activeTab);
    
    const validateTab0 = () => {
        let errorsFound = false;
        const newErrors = {
          companyNameError: !newValues.companyName ? 'Company Name is required' : errors.companyNameError || '',
          emailError: !newValues.email ? 'Email is required' : errors.emailError || '',
          mobileNumberError: !newValues.mobileNumber ? 'Mobile Number is required' : errors.mobileNumberError || '',
          passwordError: !newValues.password ? 'Password is required' : errors.passwordError || '',
          confirmPasswordError: !newValues.confirmPassword ? 'Confirm Password is required' : errors.confirmPasswordError || '',
          addressError: !newValues.address ? 'Address is required' : errors.addressError || '',
          pincodeError: !newValues.pincode ? 'Pincode is required' : errors.pincodeError || '',
          stateError: !newValues.state ? 'State is required' : errors.stateError || '',
          cinError: errors.cinError || ''
        };
        Object.keys(newErrors).forEach((key) => { if (newErrors[key]) errorsFound = true; });
        setErrors((prevError) => ({ ...prevError, ...newErrors }));
        if (!type) { setTypeError(true); errorsFound = true; } else { setTypeError(false); }
        if (newValues.brands.length === 0) { setBrandsError(true); errorsFound = true; } else { setBrandsError(false); }
        return errorsFound;
    };

    const validateTab1 = () => {
        let errorsFound = false;
        const newErrors = {
          contactEmailOneError: errors.contactEmailOneError || '', contactNameOneError: errors.contactNameOneError || '',
          contactNameTwoError: errors.contactNameTwoError || '', contactNameThreeError: errors.contactNameThreeError || '',
          contactEmailTwoError: errors.contactEmailTwoError || '', contactEmailThreeError: errors.contactEmailThreeError || '',
          contactNumberTwoError: errors.contactNumberTwoError || '', contactNumberOneError: errors.contactNumberOneError || '',
          contactNumberThreeError: errors.contactNumberThreeError || '', contactDesignationTwoError: errors.contactDesignationTwoError || '',
          contactDesignationOneError: errors.contactDesignationOneError || '', contactDesignationThreeError: errors.contactDesignationThreeError || '',
        };
        Object.keys(newErrors).forEach((key) => { if (newErrors[key]) errorsFound = true; });
        setErrors((prevError) => ({ ...prevError, ...newErrors }));
        return errorsFound;
    };

    const validateTab2 = () => {
        let errorsFound = false;
        const newErrors = {
          accountNumberError: errors.accountNumberError || '', bankNameError: errors.bankNameError || '',
          branchNameError: errors.branchNameError || '', ifscError: errors.ifscError || ''
        };
        Object.keys(newErrors).forEach((key) => { if (newErrors[key]) errorsFound = true; });
        setErrors((prevError) => ({ ...prevError, ...newErrors }));
        return errorsFound;
    };

    const hasErrors = (currentTab: number) => {
        switch (currentTab) {
            case 0: return validateTab0();
            case 1: return validateTab1();
            case 2: return validateTab2();
            case 3: return false;
            default: return false;
        }
    };

    if (newTabIndex > currentTabIndex) {
        for (let i = 0; i < newTabIndex; i++) {
            if (hasErrors(i)) {
                toast.error(`Please fix the errors in ${TAB_NAMES[i]}`);
                setTabError(i);
                return;
            }
        }
    }
    
    setActiveTab(newTabName);
    if (!viewedTabs.includes(newTabName)) {
      setViewedTabs([...viewedTabs, newTabName]);
    }
  };

  const handleNameChange = (event: any, nameField: string) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, [nameField]: value }));
    if (nameField === 'companyName' && value === '') setNewValues(prev => ({ ...prev, brands: '' }));
    if (value === '') setErrors((prevErrors) => ({ ...prevErrors, [`${nameField}Error`]: '' }));
    else if (validateCompanyName(value)) setErrors((prevErrors) => ({ ...prevErrors, [`${nameField}Error`]: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, [`${nameField}Error`]: 'Invalid Input' }));
  };

  const handleClickCancel = () => {
    onClose();
    resetState();
  };

  const handleEmailChange = (event: any, emailField: string) => {
    const { value } = event.target;
    setErrors((prevErrors) => ({ ...prevErrors, [`${emailField}Error`]: '' }));
    setNewValues((prev) => ({ ...prev, [emailField]: value }));
  };

  const handleEmailBlur = () => {
    const emailValue = newValues.email;
    if (errors.emailError) setErrors((prevErrors) => ({ ...prevErrors, emailError: errors.emailError }));
    else if (validateEmail(emailValue)) setErrors((prevErrors) => ({ ...prevErrors, emailError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, emailError: 'Please enter a valid email address.' }));
  };

  const handleEmailOneBlur = () => {
    const emailValue = newValues.contactEmailOne;
    if (emailValue === '' || validateEmail(emailValue)) setErrors((prevErrors) => ({ ...prevErrors, contactEmailOneError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, contactEmailOneError: 'Please enter a valid email address.' }));
  };

  const handleEmailTwoBlur = () => {
    const emailValue = newValues.contactEmailTwo;
    if (emailValue === '' || validateEmail(emailValue)) setErrors((prevErrors) => ({ ...prevErrors, contactEmailTwoError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, contactEmailTwoError: 'Please enter a valid email address.' }));
  };

  const handleEmailThreeBlur = () => {
    const emailValue = newValues.contactEmailThree;
    if (emailValue === '' || validateEmail(emailValue)) setErrors((prevErrors) => ({ ...prevErrors, contactEmailThreeError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, contactEmailThreeError: 'Please enter a valid email address.' }));
  };

  const handleMobileNumberBlur = () => {
    if (newValues.mobileNumber === '') setErrors((prevErrors) => ({ ...prevErrors, mobileNumberError: '' }));
    else if (errors.mobileNumberError) setErrors((prevErrors) => ({ ...prevErrors, mobileNumberError: errors.mobileNumberError }));
    else if (newValues.mobileNumber.length >= 1 && newValues.mobileNumber.length < 10) setErrors((prevErrors) => ({ ...prevErrors, mobileNumberError: 'Please enter a 10 digit number' }));
  };

  const handleNumberOneBlur = () => {
    if (newValues.contactNumberOne === '') setErrors((prevErrors) => ({ ...prevErrors, contactNumberOneError: '' }));
    else if (errors.contactNumberOneError) setErrors((prevErrors) => ({ ...prevErrors, contactNumberOneError: errors.contactNumberOneError }));
    else if (newValues.contactNumberOne.length >= 1 && newValues.contactNumberOne.length < 10) setErrors((prevErrors) => ({ ...prevErrors, contactNumberOneError: 'Please enter a 10 digit number' }));
  };

  const handleNumberTwoBlur = () => {
    if (newValues.contactNumberTwo === '') setErrors((prevErrors) => ({ ...prevErrors, contactNumberTwoError: '' }));
    else if (errors.contactNumberTwoError) setErrors((prevErrors) => ({ ...prevErrors, contactNumberTwoError: errors.contactNumberTwoError }));
    else if (newValues.contactNumberTwo.length >= 1 && newValues.contactNumberTwo.length < 10) setErrors((prevErrors) => ({ ...prevErrors, contactNumberTwoError: 'Please enter a 10 digit number' }));
  };

  const handleNumberThreeBlur = () => {
    if (newValues.contactNumberThree === '') setErrors((prevErrors) => ({ ...prevErrors, contactNumberThreeError: '' }));
    else if (errors.contactNumberThreeError) setErrors((prevErrors) => ({ ...prevErrors, contactNumberThreeError: errors.contactNumberThreeError }));
    else if (newValues.contactNumberThree.length >= 1 && newValues.contactNumberThree.length < 10) setErrors((prevErrors) => ({ ...prevErrors, contactNumberThreeError: 'Please enter a 10 digit number' }));
  };

  const handleAddressChange = (event: any) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, address: value }));
    if (value === '' || validateAddress(value)) setErrors((prevErrors) => ({ ...prevErrors, addressError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, addressError: 'Invalid Input' }));
  }; 

  const handlePhoneNumberChange = (event: any, phoneField: string) => {
      const { value } = event.target;
      if (value === '') setErrors((prevErrors) => ({ ...prevErrors, [`${phoneField}Error`]: '' }));
      else {
        const { errorMessage } = validatePhoneNumber(value);
        setErrors((prevErrors) => ({ ...prevErrors, [`${phoneField}Error`]: errorMessage }));
      }
      setNewValues(prev => ({ ...prev, [phoneField]: value }));
  };  

  const handleBankNameChange = (event: any) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, bankName: value }));
    if (value === '' || validateCompanyName(value)) setErrors((prevErrors) => ({ ...prevErrors, bankNameError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, bankNameError: 'Invalid Input.Only characters are allowed' }));
  };

  const handleBranchNameChange = (event: any) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, branchName: value }));
    if (value === '' || validateBranchName(value)) setErrors((prevErrors) => ({ ...prevErrors, branchNameError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, branchNameError: 'Invalid Input.Only characters are allowed' }));
  };

  const handleAccountNumberChange = (event: any) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, accountNumber: value }));
    if (value === '') setErrors((prevErrors) => ({ ...prevErrors, accountNumberError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, accountNumberError: validateAccountNumber(value) }));
  };

  const handleAccountTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedValue = event.target.value as string;
    setAccountType(selectedValue);
    if (selectedValue) setAccountTypeError(false); 
    setNewValues(prev => ({ ...prev, accountName: selectedValue.toLowerCase() }));
  };

  const handlePincodeBlur = () => {
    if (newValues.pincode === '') setErrors((prevErrors) => ({ ...prevErrors, pincodeError: '' }));
    else if (newValues.pincode.length >= 1 && newValues.pincode.length < 6) setErrors((prevErrors) => ({ ...prevErrors, pincodeError: 'Pincode must be 6 digits' }));
  };  

  const handleIfscBlur = () => {
    if (newValues.ifsc === '') setErrors((prevErrors) => ({ ...prevErrors, ifscError: '' }));
    else if (errors.ifscError) setErrors((prevErrors) => ({ ...prevErrors, ifscError: errors.ifscError }));
    else if (newValues.ifsc.length >= 1 && newValues.ifsc.length < 11) setErrors((prevErrors) => ({ ...prevErrors, ifscError: 'IFSC must be a 11 digit number' }));
  };  

  const handlePincodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, pincode: value }));
    const error = validatePincode(value);
    setErrors((prevErrors) => ({ ...prevErrors, pincodeError: error }));
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const password = newValues.password;
    setNewValues(prev => ({ ...prev, password: value }));
    if (!newValues.confirmPassword) {
      const error = validatePassword(value, '');
      setErrors((prevErrors) => ({ ...prevErrors, passwordError: error }));
    }
    if (newValues.confirmPassword && (password !== value)) {
      const error = validatePassword(value, newValues.confirmPassword);
      setErrors((prevErrors) => ({ ...prevErrors, passwordError: error }));
    }
  };

  const handleStateChange = (event: any) => {
    const { value } = event.target;
    const state = value.toUpperCase();
    setNewValues(prev => ({ ...prev, state: state }));
    if (state === '' || validateDriverName(state)) setErrors((prevErrors) => ({ ...prevErrors, stateError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, stateError: 'Only alphabets are allowed' }));
  };

  const handleIfscChange = (event: any) => {
    const { value } = event.target;
    const ifsc = value.toUpperCase();
    setNewValues(prev => ({ ...prev, ifsc: ifsc }));
    if (ifsc === '') setErrors((prevErrors) => ({ ...prevErrors, ifscError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, ifscError: validateIFSC(ifsc) }));
  };

  const handleCinChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const cin = value.toUpperCase();
      setNewValues(prev => ({ ...prev, cin: cin }));
      if (cin === '') setErrors((prevErrors) => ({ ...prevErrors, cinError: '' }));
      else setErrors((prevErrors) => ({ ...prevErrors, cinError: validateCin(cin) }));
  };

  const handleGSTChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const gst = value.toUpperCase();
      setNewValues(prev => ({ ...prev, gst: gst }));
      if (gst === '') setErrors((prevErrors) => ({ ...prevErrors, gstError: '' }));
      else setErrors((prevErrors) => ({ ...prevErrors, gstError: validateGST(gst, newValues.pan || '') }));
  };

  const handlePanChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const pan = value.toUpperCase();
      setNewValues(prev => ({ ...prev, pan: pan }));
      if (pan === '') setErrors((prevErrors) => ({ ...prevErrors, panError: '' }));
      else setErrors((prevErrors) => ({ ...prevErrors, panError: validatePan(pan) }));
  };

  const handleTanChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const tan = value.toUpperCase();
      setNewValues(prev => ({ ...prev, tan: tan }));
      if (tan === '') setErrors((prevErrors) => ({ ...prevErrors, tanError: '' }));
      else setErrors((prevErrors) => ({ ...prevErrors, tanError: validateTan(tan) }));
  };

  const handleCinBlur = () => {
     if (newValues.cin === '') setErrors((prevErrors) => ({ ...prevErrors, cinError: '' }));
     else if (errors.cinError) setErrors((prevErrors) => ({ ...prevErrors, cinError: errors.cinError }));
     else if (newValues.cin.length >= 1 && newValues.cin.length < 21) setErrors((prevErrors) => ({ ...prevErrors, cinError: 'CIN must be a 21 digit number' }));
  };

  const handlePanBlur = () => {
    if (newValues.pan === '') setErrors((prevErrors) => ({ ...prevErrors, panError: '' }));
    else if (errors.panError) setErrors((prevErrors) => ({ ...prevErrors, panError: errors.panError }));
    else if (newValues.pan.length >= 1 && newValues.pan.length < 10) setErrors((prevErrors) => ({ ...prevErrors, panError: 'PAN must be a 10 digit number' }));
  };

  const handleTanBlur = () => {
      if (newValues.tan === '') setErrors((prevErrors) => ({ ...prevErrors, tanError: '' }));
      else if (errors.tanError) setErrors((prevErrors) => ({ ...prevErrors, tanError: errors.tanError }));
      else if (newValues.tan.length >= 1 && newValues.tan.length < 10) setErrors((prevErrors) => ({ ...prevErrors, tanError: 'TAN must be a 10 digit number' }));
  };

  const handleGstBlur = () => {
      if (newValues.gst === '') setErrors((prevErrors) => ({ ...prevErrors, gstError: '' }));
      else if (errors.gstError) setErrors((prevErrors) => ({ ...prevErrors, gstError: errors.gstError }));
      else if (newValues.gst.length >= 1 && newValues.gst.length < 15) setErrors((prevErrors) => ({ ...prevErrors, gstError: 'GST must be a 15 digit number' }));
  };

  const handleConfirmPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, confirmPassword: value }));
    const error = validateConfirmpassword(value, newValues.password);
    setErrors((prevErrors) => ({ ...prevErrors, confirmPasswordError: error }));
  };

  const handlePasswordBlur = () => {
     if (newValues.password === '') setErrors((prevErrors) => ({ ...prevErrors, passwordError: '' }));
     else if (newValues.password.length >= 1 && newValues.password.length < 4) setErrors((prevErrors) => ({ ...prevErrors, passwordError: 'Password must be 4 digits' }));
  };  

  const handleConfirmPasswordBlur = () => {
     if (newValues.confirmPassword === '') setErrors((prevErrors) => ({ ...prevErrors, confirmPasswordError: '' }));
     else if (newValues.confirmPassword.length >= 1 && newValues.confirmPassword.length < 4) setErrors((prevErrors) => ({ ...prevErrors, confirmPasswordError: 'Password must be 4 digits' }));
  }; 

  const handleAccountNumberBlur = () => {
    if (newValues.accountNumber === '') setErrors((prevErrors) => ({ ...prevErrors, accountNumberError: '' }));
    else if (errors.accountNumberError) setErrors((prevErrors) => ({ ...prevErrors, accountNumberError: errors.accountNumberError }));
    else if (newValues.accountNumber.length >= 1 && newValues.accountNumber.length < 9) setErrors((prevErrors) => ({ ...prevErrors, accountNumberError: 'Please enter atleast 9 digits' }));
  };

  const handleCompanyNameBlur = () => {
    const companyName = newValues.companyName || '';  
    if (errors.companyNameError) {
      setErrors((prevErrors) => ({ ...prevErrors, companyNameError: errors.companyNameError })); 
    }
    if (!errors.companyNameError && companyName) {
      setNewValues((prevState) => ({ ...prevState, brands: companyName }));
      setBrandsError(false);
    }
  };
  
  const handleCompanyNameChange = (event: any) => {
    const { value } = event.target;
    setNewValues(prev => ({ ...prev, companyName: value }));
  
    if (value === '') setNewValues(prev => ({ ...prev, brands: '' }));
  
    if (value === '') setErrors((prevErrors) => ({ ...prevErrors, companyNameError: '' }));
    else if (validateCompanyName(value)) setErrors((prevErrors) => ({ ...prevErrors, companyNameError: '' }));
    else setErrors((prevErrors) => ({ ...prevErrors, companyNameError: 'Invalid Input' }));
  };

  const panMatchingGst = (panNumber: string, gstNumber: string) => {
    return (
      panNumber.length === 10 &&
      gstNumber.length === 15 &&
      panNumber === gstNumber.slice(2, 12)
    );
  };

  const handleFeatureCheckboxChange = (featureId: number) => {
    setSelectedFeatures((prev) => 
      prev.includes(featureId) ? prev.filter(id => id !== featureId) : [...prev, featureId]
    );
  };

  const handleClickSave = () => {
      setErrors((prevError) => ({
        ...prevError,
        panError: prevError.panError || '',
        tanError: prevError.tanError || '',
        gstError: prevError.gstError || '',
      }));

      if (errors.panError || errors.tanError || errors.gstError) {
        toast.error("Please resolve the errors");
        return;
      }
      if (newValues.pan && newValues.gst) {
        const panMatchesGst = panMatchingGst(newValues.pan, newValues.gst);
        if (!panMatchesGst) {
          toast.error("PAN number does not match with the GST number.");
          return;
        }
      }

      if (!errors.panError && !errors.tanError && !errors.gstError) {
        addCompany(
            newValues.companyName, newValues.email, newValues.password, newValues.confirmPassword,
            newValues.mobileNumber, newValues.address, newValues.pincode, newValues.accountName,
            newValues.accountNumber, newValues.bankName, newValues.branchName, newValues.ifsc,
            newValues.contactNameOne, newValues.contactEmailOne, newValues.contactNumberOne, newValues.contactDesignationOne,
            newValues.contactNameTwo, newValues.contactEmailTwo, newValues.contactNumberTwo, newValues.contactDesignationTwo,
            newValues.contactNameThree, newValues.contactEmailThree, newValues.contactNumberThree, newValues.contactDesignationThree,
            newValues.pan, newValues.gst, newValues.tan, newValues.state, newValues.cin,
            type, newValues.brands,
            selectedFiles.logo, selectedFiles.pan, selectedFiles.gst, selectedFiles.tan, selectedFiles.cancelledCheque,
            (response: any) => {
              
              const companyId = response?.company?.id || response?.data?.company?.id || response?.data?.id || response?.id; 

              if (companyId && selectedFeatures.length > 0) {
                addFeatures(
                  companyId,
                  selectedFeatures,
                  (featureRes: any) => {
                    toast.success(response.message || "Company and features added successfully");
                    onClose();
                    resetState();
                    setTimeout(() => { window.location.reload(); }, 3000);
                  },
                  (featureErr: any) => {
                    toast.error("Company created, but failed to save features.");
                    onClose();
                    resetState();
                    setTimeout(() => { window.location.reload(); }, 3000);
                  }
                );
              } else {
                toast.success(response.message || "Company added successfully");
                onClose();
                resetState();
                setTimeout(() => { window.location.reload(); }, 3000);
              }
            },
           (errMessage: any) => {
            const emailError = errMessage?.message?.errors?.email?.[0];
            const generalMessage = errMessage?.message?.message || errMessage?.message;
            if (emailError) {
              toast.error(emailError);
            } else if (generalMessage) {
              toast.error(generalMessage);
            }
           }
         );
      }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
     const fileInput = event.target; 
     const file = fileInput.files?.[0] || null;
     if (file) {
        if (file.size > maxFileSize) {
            toast.error("File size must not exceed 1 MB");
            resetFileSelection(type); 
            return;
        }
        if (!allowedFileTypes.includes(file.type)) {
            toast.error("File type not supported");
            resetFileSelection(type); 
            return;
        }
      }
    setSelectedFiles((prevFiles) => ({ ...prevFiles, [type]: file }));
    setIcons((prevIcons) => ({ ...prevIcons, [type]: file ? 'view' : 'upload' }));
    fileInput.value = '';
  };

  const resetFileSelection = (type: string) => {
    setSelectedFiles((prevFiles) => ({ ...prevFiles, [type]: null }));
    setIcons((prevIcons) => ({ ...prevIcons, [type]: 'upload' }));
  };

  const handleIconClick = (type: string, action: string) => {
    if (action === 'view') {
      const file = selectedFiles[type];
      if (file) {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } 
    }
    else if (action === 'remove') {
      resetFileSelection(type);
    }
  };

  const renderFileInput = (label: string, type: string) => {
    const isSpecialField = label === 'Cancelled Cheque' || label === 'Logo';
    const containerStyle = { display: 'flex', alignItems: 'center', ...(isSpecialField ? {  } : {}) };
    const viewCloseStyle = { cursor: 'pointer', color: 'blue', marginRight: '10px', ...(isSpecialField ? { } : {}) };
    return (
      <div key={type} style={containerStyle}>
         <div style={{ display: 'flex', alignItems: 'center'}}>
          <p style={{ marginRight: '10px', width: '180px' }}>{label}</p>
          <input accept="*" style={{ display: 'none' }} id={`${type}-file`} type="file" onChange={(e) => handleFileChange(e, type)} />
          <label htmlFor={`${type}-file`}>
            {icons[type] === 'upload' && (
              <Tooltip title="Upload File">
                <IconButton component="span">
                  <UploadIcon color="primary" />
                </IconButton>
              </Tooltip>
            )}
          </label>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {icons[type] === 'view' && (
            <Tooltip title="View File">
              <span style={viewCloseStyle} onClick={() => handleIconClick(type, 'view')}>
                View
              </span>
            </Tooltip>
          )}
          {icons[type] === 'view' && (
            <Tooltip title="Remove File">
              <IconButton sx={{ color: 'red' }} component="span" onClick={() => handleIconClick(type, 'remove')}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Box sx={{ marginLeft: { xs: '0px', sm: '-180px' } }}>
         <Heading title="Add Company" closeIcon="true" onClose={onClose} />
      </Box>
      <DialogContent>
        
        {/* Using your specific Custom Tabs Component import */}
        <Box sx={{ mb: 3 }}>
          <StatusFilterTabs 
             tabs={TAB_NAMES} 
             activeTab={activeTab} 
             onTabChange={handleTabChange}
             viewedTabs={viewedTabs} 
          />
        </Box>

        {/* --- Tab 0: Company Details --- */}
        <TabPanel value={activeTab} index="Company">
          <Box className="form-section">
            <Box className="form-group">
              <TextField variant="outlined" size="small" label={createMandatoryLabel('Company Name')} name="name" value={newValues.companyName} onChange={(e) => handleNameChange(e,'companyName')} onBlur={handleCompanyNameBlur} error={!!errors.companyNameError} helperText={errors.companyNameError} className="styled-textfield-width" />
              <TextField variant="outlined" size="small" name="mobileNumber" label={createMandatoryLabel('Mobile Number')} value={newValues.mobileNumber} onChange={(e) => handlePhoneNumberChange(e,'mobileNumber')} onBlur={handleMobileNumberBlur} error={!!errors.mobileNumberError} helperText={errors.mobileNumberError} className="styled-textfield-width" />
            </Box>
            <Box className="form-group">
              <Dropdown options={typesOptions} selectedValue={type} handleChange={handleTypeChange} placeholder="Select Type" label={createMandatoryLabel('Select Type')} width="225px" height="41px" error={typeError} helperText={typeError ? 'This field is required' : ''} />
              <TextField variant="outlined" size="small" name="email" label={createMandatoryLabel('Email')} value={newValues.email} onChange={(e) => handleEmailChange(e,'email')} onBlur={handleEmailBlur} error={!!errors.emailError} helperText={errors.emailError} className="styled-textfield-width" />
            </Box>
            <Box className="form-group">
              <TextField variant="outlined" size="small" name="password" label={createMandatoryLabel('Password')} type="password" value={newValues.password} onChange={handlePasswordChange} onBlur={handlePasswordBlur} error={!!errors.passwordError} helperText={errors.passwordError} className="styled-textfield-width" />
              <TextField variant="outlined" size="small" name="confirm password" label={createMandatoryLabel('Confirm Password')} type="password" value={newValues.confirmPassword} onChange={handleConfirmPasswordChange} onBlur={handleConfirmPasswordBlur} error={!!errors.confirmPasswordError} helperText={errors.confirmPasswordError} disabled={!newValues.password} className="styled-textfield-width" />
            </Box>
            <Box className="form-group">
              <TextField variant="outlined" size="small" name="address" label={createMandatoryLabel('Address')} value={newValues.address} onChange={handleAddressChange} error={!!errors.addressError} helperText={errors.addressError} className="styled-textfield-width" />
              <TextField variant="outlined" size="small" name="pincode" label={createMandatoryLabel('Pincode')} value={newValues.pincode} onChange={handlePincodeChange} onBlur={handlePincodeBlur} error={!!errors.pincodeError} helperText={errors.pincodeError} className="styled-textfield-width" />
            </Box>
            <Box className="form-group">
              <TextField variant="outlined" size="small" name='brand_name' value={newValues.brands} label={createMandatoryLabel('Brands')} placeholder="Enter brand name" className="styled-textfield-width" error={!!brandsError || !!brandError} helperText={brandsError ? 'This field is required' : brandError} aria-readonly />
              <TextField variant="outlined" size="small" name="state" label={createMandatoryLabel('State')} value={newValues.state} onChange={handleStateChange} error={!!errors.stateError} helperText={errors.stateError} className="styled-textfield-width" />
            </Box>
            <Box className="form-group">
              <TextField variant="outlined" size="small" name="cin" label='CIN' value={newValues.cin} onChange={handleCinChange} onBlur={handleCinBlur} error={!!errors.cinError} helperText={errors.cinError} className="styled-textfield-width" />
            </Box>
            <div style={{ marginLeft: '230px', marginTop: '5px' }}>
               <Button className='custom-button' onClick={() => handleTabChange('Details')}>Next</Button>
               <div style={{ marginLeft: '150px', marginTop: '-30px', fontSize: '12px', color: 'red' }}>(All * fields are mandatory)</div>
            </div>
          </Box>
        </TabPanel>

        {/* --- Tab 1: Additional Details --- */}
        <TabPanel value={activeTab} index="Details">
           <Box className="form-section-additional">
              <Typography variant="h6" style={{ fontSize: '16px', marginBottom: '10px', marginTop: '-10px' }}>Contact Person 1</Typography>
              <Box className="form-group-additional">
                 <TextField variant="outlined" size="small" label="Name" name="contactNameOne" value={newValues.contactNameOne} onChange={(e) => handleNameChange(e,'contactNameOne')} error={!!errors.contactNameOneError} helperText={errors.contactNameOneError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="contactNumberOne" label="Mobile Number" value={newValues.contactNumberOne} onChange={(e) => handlePhoneNumberChange(e,'contactNumberOne')} onBlur={handleNumberOneBlur} error={!!errors.contactNumberOneError} helperText={errors.contactNumberOneError} className="styled-textfield-width" />
              </Box>
              <Box className="form-group-additional">
                 <TextField variant="outlined" size="small" name="contactEmailOne" label='Email' value={newValues.contactEmailOne} onChange={(e) => handleEmailChange(e,'contactEmailOne')} onBlur={handleEmailOneBlur} error={!!errors.contactEmailOneError} helperText={errors.contactEmailOneError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="contactDesignationOne" label="Designation" value={newValues.contactDesignationOne} onChange={(e) => handleNameChange(e,'contactDesignationOne')} error={!!errors.contactDesignationOneError} helperText={errors.contactDesignationOneError} className="styled-textfield-width" />
              </Box>

              <Typography variant="h6" style={{ fontSize: '16px', marginBottom: '10px', marginTop: '-10px' }}>Contact Person 2</Typography>
              <Box className="form-group-additional">
                 <TextField variant="outlined" size="small" label="Name" name="contactNameTwo" value={newValues.contactNameTwo} onChange={(e) => handleNameChange(e,'contactNameTwo')} error={!!errors.contactNameTwoError} helperText={errors.contactNameTwoError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="contactMobileTwo" label="Mobile Number" value={newValues.contactNumberTwo} onChange={(e) => handlePhoneNumberChange(e,'contactNumberTwo')} onBlur={handleNumberTwoBlur} error={!!errors.contactNumberTwoError} helperText={errors.contactNumberTwoError} className="styled-textfield-width" />
              </Box>
              <Box className="form-group-additional">
                 <TextField variant="outlined" size="small" name="contactEmailTwo" label="Email" value={newValues.contactEmailTwo} onChange={(e) => handleEmailChange(e,'contactEmailTwo')} onBlur={handleEmailTwoBlur} error={!!errors.contactEmailTwoError} helperText={errors.contactEmailTwoError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="contactDesignationTwo" label="Designation" value={newValues.contactDesignationTwo} onChange={(e) => handleNameChange(e,'contactDesignationTwo')} error={!!errors.contactDesignationTwoError} helperText={errors.contactDesignationTwoError} className="styled-textfield-width" />
              </Box>

              <Typography variant="h6" style={{fontSize: '16px', marginBottom: '10px', marginTop: '-10px' }}>Contact Person 3</Typography>
              <Box className="form-group-additional">
                 <TextField variant="outlined" size="small" label="Name" name="contactNameThree" value={newValues.contactNameThree} onChange={(e) => handleNameChange(e,'contactNameThree')} error={!!errors.contactNameThreeError} helperText={errors.contactNameThreeError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="contactMobileThree" label="Mobile Number" value={newValues.contactNumberThree} onChange={(e) => handlePhoneNumberChange(e,'contactNumberThree')} onBlur={handleNumberThreeBlur} error={!!errors.contactNumberThreeError} helperText={errors.contactNumberThreeError} className="styled-textfield-width" />
              </Box>
              <Box className="form-group-additional">
                 <TextField variant="outlined" size="small" name="contactEmailThree" label="Email" value={newValues.contactEmailThree} onChange={(e) => handleEmailChange(e,'contactEmailThree')} onBlur={handleEmailThreeBlur} error={!!errors.contactEmailThreeError} helperText={errors.contactEmailThreeError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="contactDesignationThree" label="Designation" value={newValues.contactDesignationThree} onChange={(e) => handleNameChange(e,'contactDesignationThree')} error={!!errors.contactDesignationThreeError} helperText={errors.contactDesignationThreeError} className="styled-textfield-width" />
              </Box>
              
              <div style={{ marginLeft: '230px', marginTop: '5px' }}>
                 <Button className="custom-button" onClick={() => handleTabChange('Bank')}>Next</Button>
                 <div style={{ marginLeft: '150px', marginTop: '-30px', fontSize: '12px', color: 'red' }}>(All * fields are mandatory)</div>
              </div>
           </Box>
        </TabPanel>

        {/* --- Tab 2: Bank Details --- */}
        <TabPanel value={activeTab} index="Bank">
           <Box className="form-section">
              <Box className="form-group">
                 <TextField variant="outlined" size="small" label='Bank Name' name="bankName" value={newValues.bankName} onChange={handleBankNameChange} error={!!errors.bankNameError} helperText={errors.bankNameError} className="styled-textfield-width" />
                 <TextField variant="outlined" size="small" name="branchName" label='Branch Name' value={newValues.branchName} onChange={handleBranchNameChange} error={!!errors.branchNameError} helperText={errors.branchNameError} className="styled-textfield-width" />
              </Box>
              <Box className="form-group">
                 <TextField variant="outlined" size="small" name="accountNumber" label='Account Number' value={newValues.accountNumber} onChange={handleAccountNumberChange} onBlur={handleAccountNumberBlur} error={!!errors.accountNumberError} helperText={errors.accountNumberError} className="styled-textfield-width" />
                 <Dropdown options={accountTypesOptions} selectedValue={accountType} handleChange={handleAccountTypeChange} placeholder="Select Account Type" label='Select Account Type' width="224px" height="41px" error={accountTypeError} helperText={accountTypeError ? 'This field is required' : ''} />
              </Box>
              <Box className="form-group">
                 <TextField variant="outlined" size="small" name="ifsc" label='IFSC' value={newValues.ifsc} onChange={handleIfscChange} onBlur={handleIfscBlur} error={!!errors.ifscError} helperText={errors.ifscError} className="styled-textfield-width" />
              </Box>
              <div style={{ marginLeft: '250px', marginTop: '5px' }}>
                 <Button className='custom-button' onClick={() => handleTabChange('Documents')}>Next</Button>
                 <div style={{ marginLeft: '150px', marginTop: '-30px', fontSize: '12px', color: 'red' }}>(All * fields are mandatory)</div>
              </div>
           </Box>
        </TabPanel>

        {/* --- Tab 3: Documents --- */}
        <TabPanel value={activeTab} index="Documents">
           <Box className="form-section-icon">
              <Box className="form-group-icon">
                 <Box className="form-input-icon" display="flex" alignItems="center" justifyContent="space-between">
                    {renderFileInput('PAN', 'pan')} 
                    <TextField variant="outlined" size="small" name="pan" label='PAN' value={newValues.pan} onChange={handlePanChange} onBlur={handlePanBlur} error={!!errors.panError} helperText={errors.panError} className="styled-textfield-width" />
                 </Box>
                 <Box className="form-input-icon" display="flex" alignItems="center" justifyContent="space-between">
                    {renderFileInput('TAN', 'tan')} 
                    <TextField variant="outlined" size="small" name="tan" label='TAN' value={newValues.tan} onChange={handleTanChange} onBlur={handleTanBlur} error={!!errors.tanError} helperText={errors.tanError} className="styled-textfield-width" />
                 </Box>
                 <Box className="form-input-icon" display="flex" alignItems="center" justifyContent="space-between">
                    {renderFileInput('GST', 'gst')} 
                    <TextField variant="outlined" size="small" name="gst" label='GST' value={newValues.gst} onChange={handleGSTChange} onBlur={handleGstBlur} error={!!errors.gstError} helperText={errors.gstError} className="styled-textfield-width" />
                 </Box>
                 <Box className="form-input-icon">{renderFileInput('Cancelled Cheque', 'cancelledCheque')}</Box>
                 <Box className="form-input-icon">{renderFileInput('Logo', 'logo')}</Box>
              </Box>
              
              <div style={{ marginLeft: '250px', marginTop: '20px' }}>
                <Button className='custom-button' onClick={() => handleTabChange('Features')}>Next</Button>
              </div>
           </Box>
        </TabPanel>

        {/* --- Tab 4: Features --- */}
        <TabPanel value={activeTab} index="Features">
           <Box className="form-section">
             
             {(() => {
               const dashboardFeatures = featuresList.filter(f => f.feature_name?.toLowerCase().includes('dashboard'));
               const reportFeatures = featuresList.filter(f => f.feature_name?.toLowerCase().includes('report'));
               const otherFeatures = featuresList.filter(
                 f => !f.feature_name?.toLowerCase().includes('dashboard') && !f.feature_name?.toLowerCase().includes('report')
               );

               const renderFeatureCheckboxes = (features: any[]) => (
                 <FormGroup sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' }}>
                   {features.map((feature: any) => (
                     <FormControlLabel
                       key={feature.id}
                       control={
                         <Checkbox
                           checked={selectedFeatures.includes(feature.id)}
                           onChange={() => handleFeatureCheckboxChange(feature.id)}
                         />
                       }
                       label={
                         feature.feature_name 
                           ? feature.feature_name
                               .replace(/_/g, ' ')
                               .replace(/\b\w/g, (char: string) => char.toUpperCase())
                           : `Feature ${feature.id}`
                       } 
                     />
                   ))}
                 </FormGroup>
               );

               return (
                 <>
                   {/* Dashboard Features Section */}
                   {dashboardFeatures.length > 0 && (
                     <Box sx={{ mb: 2 }}>
                       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                         <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                           Dashboard
                         </Typography>
                         <IconButton
                           size="small"
                           onClick={() => setDashboardExpanded(!dashboardExpanded)}
                           sx={{ padding: '4px' }}
                         >
                           {dashboardExpanded ? <RemoveIcon /> : <AddIcon />}
                         </IconButton>
                       </Box>
                       {dashboardExpanded && (
                         <Box sx={{ paddingLeft: '15px', mt: 1.5 }}>
                           {renderFeatureCheckboxes(dashboardFeatures)}
                         </Box>
                       )}
                     </Box>
                   )}

                   {/* Report Features Section */}
                   {reportFeatures.length > 0 && (
                     <Box sx={{ mb: 2 }}>
                       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                         <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                           Reports
                         </Typography>
                         <IconButton
                           size="small"
                           onClick={() => setReportsExpanded(!reportsExpanded)}
                           sx={{ padding: '4px' }}
                         >
                           {reportsExpanded ? <RemoveIcon /> : <AddIcon />}
                         </IconButton>
                       </Box>
                       {reportsExpanded && (
                         <Box sx={{ paddingLeft: '15px', mt: 1.5 }}>
                           {renderFeatureCheckboxes(reportFeatures)}
                         </Box>
                       )}
                     </Box>
                   )}

                   {/* Other Features */}
                   {otherFeatures.length > 0 && (
                     <Box sx={{ mb: 0 }}>
                       <Typography sx={{ fontWeight: 'bold', fontSize: '16px', mb: 1.5 }}>
                         General Features
                       </Typography>
                       <Box sx={{ paddingLeft: '15px' }}>
                         {renderFeatureCheckboxes(otherFeatures)}
                       </Box>
                     </Box>
                   )}
                 </>
               );
             })()}

             <div style={{ marginLeft: '210px', marginTop: '30px' }}>
               <Button className='custom-button' onClick={handleClickSave}>Save</Button>
             </div>
             <div style={{ marginLeft: '280px', marginTop: '-38px' }}>
               <Button className='custom-cancel-button' onClick={handleClickCancel}>Cancel</Button>
               <div style={{ marginLeft: '120px', marginTop: '-30px', fontSize: '12px', color: 'red' }}>(All * fields are mandatory)</div>
             </div>
           </Box>
        </TabPanel>

      </DialogContent>
    </Dialog>
  );
};

const TabPanel = ({ children, value, index }: any) => {
  return value === index ? <Box>{children}</Box> : null;
};

export default AddCompanyModal;